import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import NeighborhoodListActions from '../ducks/neighborhood-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/neighborhood`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(NeighborhoodListActions.success(data, pagination));
  } catch (err) {
    yield put(NeighborhoodListActions.failure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/neighborhood?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(NeighborhoodListActions.showSuccess(list));
  } catch (err) {
    yield put(
      NeighborhoodListActions.showFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
